import { HTTPClient, propsToDate } from "@abaco/web-common/src/HTTP";
import { ProtocolViolation } from "../models/Violation";

export default class ViolationApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async executeChecks(pk_cuaa: number, campaign: number): Promise<ProtocolViolation[]> {
        const url = `${this.rootPath}/v1/protocols/subjects/${pk_cuaa}/${campaign}/protocols_checks`
        const res = await this.http.post(url);

        let protocols: ProtocolViolation[] = res.data;
        protocols = protocols.map(protocol => ({
            ...protocol,
            protocol_violations: protocol.protocol_violations.map(violation => {
                propsToDate(violation, ["dt_update", "event_date"])
                return violation;
            })
        }));
        return res.data;
    }

    public async hasViolations(pk_cuaa: number, campaign: number): Promise<boolean> {
        const url = `${this.rootPath}/v1/protocols/subjects/${pk_cuaa}/${campaign}/protocols_checks`
        const res = await this.http.post(url);
        let protocols: ProtocolViolation[] = res.data;
        protocols = protocols.map(protocol => ({
            ...protocol,
            protocol_violations: protocol.protocol_violations.map(violation => {
                propsToDate(violation, ["dt_update", "event_date"])
                return violation;
            })
        }));
        return res.data && res.data.length > 0 ? true : false;
    }
}
